module.exports = __webpack_public_path__ + "static/media/logo_crazy_kings.e728e61c.png";